/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Switch, Redirect } from "react-router-dom";

import { ContentRoute } from "../../../../_metronic/layout";
import Footer from "../../../../_metronic/layout/components/footer/Footer";
import { ErrorPage1 } from "../../ErrorsExamples/ErrorPage1";

import ApprovedLink from "./ApprovedLink";
import CategoryAssets from "./CategoryAssets";
import Dashboard from "./Dashboard";
import ForgotPassword from "./ForgotPassword";
import Logout from "./Logout";
import { OrganizationModal } from "./Organization";
import OrganizationJoin from "./OrganizationJoin";
import RolePage from "./RolePage";
import SetPassword from "./SetPassword";

import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

export function AuthPage() {
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*Begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid"
          id="kt_login"
        >
          {/*Begin::Aside*/}
          <Switch>
            <ContentRoute strict path="/auth/dashboard" component={Dashboard} />
            <ContentRoute exact path="/auth/dashboard123" component={Footer} />
            <ContentRoute
              exact
              path="/auth/organization-profile"
              component={OrganizationModal}
            />
            <ContentRoute
              exact
              path="/auth/join-organization"
              component={OrganizationJoin}
            />
            <ContentRoute exact path="/auth/role" component={RolePage} />
            <ContentRoute
              exact
              path="/auth/approved-link/:id"
              component={ApprovedLink}
            />
            <ContentRoute
              exact
              path="/auth/set-password/:id"
              component={SetPassword}
            />
            <ContentRoute
              exact
              path="/auth/approved-link/:id"
              component={ApprovedLink}
            />
            <ContentRoute
              exact
              path="/auth/forgot-password"
              component={ForgotPassword}
            />
            <ContentRoute
              exact
              path="/categories/:id"
              component={CategoryAssets}
            />
            <ContentRoute exact path="/auth/logout" component={Logout} />
            <Redirect from="/auth" exact={true} to="auth/login" />
            <Redirect to="/auth/logout" />
            <ContentRoute component={ErrorPage1} />
          </Switch>
          {/*End::Aside*/}
        </div>
        {/*End::Login*/}
      </div>
    </>
  );
}
